module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      width: _vm.appWidth
    })
  }, [_c('AppHeader'), _vm._v(" "), _c('div', [_c('main', {
    staticClass: "main",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('AppFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd011ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full2.vue
// module id = 1083
// module chunks = 284